import { Campaign } from '@core/types';
import { normalizePath, getUrlParams, matchesQueryParameters } from '@shared/utils/dom';

export class PageMatcher {
  getCurrentPath(): string {
    return normalizePath(window.location.pathname);
  }

  getUrlParams(): Record<string, string> {
    return getUrlParams();
  }

  matches(campaign: Campaign): boolean {
    // Check if campaign is null or has query parameters defined
    if (!campaign || !campaign.query_parameters || typeof campaign.query_parameters !== 'object') {
      return false;
    }

    const queryKeys = Object.keys(campaign.query_parameters);
    if (queryKeys.length === 0) {
      return false;
    }

    const urlParams = this.getUrlParams();

    // Check if required keys are present in URL
    for (const key of queryKeys) {
      if (!Object.prototype.hasOwnProperty.call(urlParams, key)) {
        return false;
      }
    }

    // Full match check (value comparisons + null/'' meaning "exists")
    return matchesQueryParameters(campaign.query_parameters, urlParams);
  }

  hasModificationsForPath(campaign: Campaign, path: string): boolean {
    const pageMods = campaign.modifications?.[path];
    return Array.isArray(pageMods) && pageMods.length > 0;
  }

  getActiveCampaigns(campaigns: Campaign[]): Campaign[] {
    const currentPath = this.getCurrentPath();

    return campaigns.filter((campaign) => {
      if (!this.matches(campaign)) {
        return false;
      }

      return this.hasModificationsForPath(campaign, currentPath);
    });
  }

  buildRunKey(campaignId: number, path: string, search: string): string {
    return `${campaignId}|${path}|${search}`;
  }
}
